import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const getBookingRateAtom = atom((get) => {
  const booking = get(currentBookingAtom);
  return (
    booking?.bookingRates.find((rate) => rate.id === booking.rateId) ?? null
  );
});
